import React from 'react';
import { CountdownProvider } from './contexts/CountdownContext';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludedSection } from './components/IncludedSection';
import { PlannerCarousel } from './components/PlannerCarousel';
import { ResultsSection } from './components/ResultsSection';
import { AboutVictoria } from './components/AboutVictoria';
import { Testimonials } from './components/Testimonials';
import { PurchaseSection } from './components/PurchaseSection';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <CountdownProvider data-id="element-0" data-mp="2wi5m1f302hnq">
      <div className="w-full bg-polar font-sans" data-id="element-1" data-mp="28tw5arkn8k3g">
        <TopBar data-id="element-2" data-mp="28sl511qepuh3" />
        <main data-id="element-3" data-mp="28s2zfehuu3wi">
          <Hero data-id="element-4" data-mp="23vkw8j26adma" />
          <ProblemSection data-id="element-5" data-mp="23w4fq47h1a2f" />
          <SolutionSection data-id="element-6" data-mp="23ujha3i1d6za" />
          <IncludedSection data-id="element-7" data-mp="23t8eo70bu59r" />
          <PlannerCarousel data-id="element-8" data-mp="3ik7jmqgv0tve" />
          <ResultsSection data-id="element-9" data-mp="3iiwasc8k4vxf" />
          <AboutVictoria data-id="element-10" data-mp="3ijpet5g4t7bv" />
          <Testimonials data-id="element-11" data-mp="3mlj98vzqhf3l" />
          <PurchaseSection data-id="element-12" data-mp="3mkrefndynled" />
          <Faq data-id="element-13" data-mp="3mjzrt22ccy08" />
        </main>
        <Footer data-id="element-14" data-mp="3mj6k9yvk64h1" />
      </div>
    </CountdownProvider>;
}